<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'Backup',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-database-2-line',
  color: 'error',
  title: 'Backup & Restore',
  description: 'Membuat backup manual dan memulihkan data dari arsip backup.',
  purpose: 'Panduan membuat cadangan data secara manual dan memulihkannya kembali kalau terjadi masalah.',
  concept: [
    {
      icon: 'ri-archive-line',
      title: 'Satu Arsip Berisi Semuanya',
      text: 'Satu file backup (.zip) berisi seluruh data database dan file yang tersimpan (Dokumen, Evidence, dst.) pada saat backup dibuat.',
    },
    {
      icon: 'ri-timer-line',
      title: 'Backup Lama Dihapus Otomatis',
      text: 'Sistem hanya menyimpan sejumlah backup terbaru (retensi otomatis) — backup yang lebih lama dari itu dihapus otomatis supaya penyimpanan tidak penuh.',
    },
  ],
  steps: [
    { title: 'Buka menu Backup & Restore', detail: 'Lihat riwayat backup yang pernah dibuat.' },
    { title: 'Klik "Backup Sekarang"', detail: 'Tunggu sampai proses selesai — muncul baris baru di riwayat dengan status "success".' },
    { title: 'Klik ikon unduh untuk menyimpan salinan ke luar sistem', detail: 'Sangat disarankan — simpan salinan di USB/drive lain secara berkala, jangan hanya mengandalkan penyimpanan lokal.' },
    { title: 'Untuk restore: klik "Restore dari Arsip"', detail: 'Unggah file backup (.zip), baca peringatan dengan teliti, lalu klik "Restore".' },
  ],
  warning: 'Restore akan MENIMPA seluruh data saat ini dengan data dari arsip backup. Pastikan Anda benar-benar yakin — dan sebaiknya buat backup baru dari kondisi saat ini dulu sebelum melakukan restore, jaga-jaga.',
  tips: [
    'Jadwalkan backup manual secara rutin (mis. tiap minggu) sampai backup terjadwal otomatis dikonfigurasi.',
    'Pindahkan file backup ke media eksternal (USB/drive lain) — QUALIVA tidak memaksa cloud backup, jadi tanggung jawab menyimpan salinan aman ada di Anda.',
  ],
  faq: [
    { q: 'Setelah restore selesai, apakah saya perlu melakukan sesuatu lagi?', a: 'Ya — restart Local Service (layanan aplikasi) secara manual setelah restore selesai, supaya seluruh koneksi/cache aplikasi memuat ulang data yang baru dipulihkan.' },
    { q: 'Apakah file backup saya aman kalau dilihat orang lain?', a: 'Arsip backup TIDAK menyertakan file konfigurasi (.env) yang berisi kredensial sensitif — tapi tetap perlakukan file backup sebagai data rahasia karena berisi seluruh data operasional Anda.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
